/**
 * DEPRECATED: Debug logging is now unified in DebugLogger.js
 *
 * This file exists for backward compatibility.
 * All functionality is provided by DebugLogger.js which exposes both:
 *   - window.Debug (this API)
 *   - window.DebugLogger
 *
 * See DebugLogger.js for available categories and usage.
 */

// Re-export the unified debug system
// DebugLogger.js sets window.Debug = DebugLogger for us

const Debug = (typeof window !== 'undefined' && window.Debug) || {
  // Fallback for SSR/tests - minimal stub
  log: () => {},
  warn: () => {},
  error: (...args) => console.error(...args),
  group: () => {},
  groupEnd: () => {},
  time: () => {},
  timeEnd: () => {},
  isEnabled: () => false,
  toggle: () => false,
  enableAll: () => {},
  disableAll: () => {},
  categories: [],
};

// Export for different module systems
if (typeof module !== 'undefined' && module.exports) {
  module.exports = Debug;
}
